import { Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { AuthService } from '@authentication';
import { UIIconComponent, UiLoadingComponent } from '@design-system';
import {
	MINIMUM_DISPLAY_MS,
	SPLASH_SUBTITLE,
	SPLASH_SUBTITLE_WORDS,
	SPLASH_TEXTURE_URL
} from './domain/splash-screen.constants';

/**
 * The launch screen — Figma «Splash» (Kala Handoff, page «Splash Screen»).
 *
 * It plays the brand intro for at least `MINIMUM_DISPLAY_MS`, then stays up for as
 * long as login is still pending; only that wait past the intro shows the spinner,
 * which is the difference between the design's two Splash frames.
 */
@Component({
	selector: 'app-splash-screen',
	imports: [UiLoadingComponent, UIIconComponent],
	templateUrl: './splash-screen.component.html',
	styleUrl: './splash-screen.component.scss'
})
export class SplashScreenComponent implements OnInit {
	readonly authService = inject(AuthService);
	private readonly destroyRef = inject(DestroyRef);

	readonly showMinimum = signal(true);
	readonly isVisible = computed(() => this.authService.waitingForLogin() || this.showMinimum());
	readonly showLoader = computed(() => !this.showMinimum() && this.authService.waitingForLogin());

	readonly textureUrl = SPLASH_TEXTURE_URL;
	readonly subtitle = SPLASH_SUBTITLE;
	readonly subtitleWords = SPLASH_SUBTITLE_WORDS;

	ngOnInit(): void {
		const timeoutId = setTimeout(() => {
			this.showMinimum.set(false);
		}, MINIMUM_DISPLAY_MS);

		this.destroyRef.onDestroy(() => clearTimeout(timeoutId));
	}
}
